import { createGateway as createMoveItemsGateway } from '@updater-core/gateways/move-items';
import createDomainTrackerInteractor from '@updater-core/interactors/domain-tracker';
import session from '@updater-core/interactors/shell/session';
import createMoveItemsInteractor from './interactor';
import { MoveItemsInteractor } from './types.d';

export default function createInteractor(): MoveItemsInteractor {
  const moveItemsGateway = createMoveItemsGateway({ interactors: { session } });

  const stepTracker = createDomainTrackerInteractor({ domain: 'step' });

  const interactor = createMoveItemsInteractor({
    interactors: {
      stepTracker,
      session,
    },
    gateways: {
      moveItems: moveItemsGateway,
    },
  });

  return interactor;
}
